import {SUPPORTED_LANGUAGE} from "../../common/i18n/locales/localeConstant";
import {selectedLocaleChanged} from "../../common/common";

const LocaleReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOCALE":
            return changeLanguage(state, action.payload);
        case "ROUTE_CHANGED":
            return {
                ...state
            };
        default:
            return state;
    }
};

const changeLanguage = (state, payload) => {
    // Check if selected locale already preselected
    if (state.locale === payload.value) {
        return {
            ...state
        };
    }

    const newLocale = SUPPORTED_LANGUAGE?.hasOwnProperty(payload.value) ? SUPPORTED_LANGUAGE[payload.value] : undefined;
    if (!newLocale) {
        return {
            ...state
        };
    }
    window.localStorage.setItem("locale", newLocale);
    selectedLocaleChanged(state.locale, newLocale, payload.localizedState, payload?.composePages);

    return {
        ...state,
        locale: newLocale
    };
};

export default LocaleReducer;
